export default __webpack_public_path__ + "static/media/examples-Illustration.189ee5e7.svg";